import { useMutation, useQueryClient } from "react-query";
import {
  createGoals,
  deleteGoals,
  getProfitAndLossReport,
  updateGoals,
} from "../../../services/performance";

// Custom hook to get profit and loss report using mutation
export const useReportMutation = () => {
  return useMutation((data) => getProfitAndLossReport(data));
};

export const useCreateGoalsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createGoals(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getGoals"]);
    },
  });
};

export const useUpdateGoalsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateGoals(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getGoals"]);
    },
  });
};

export const useDeleteGoalsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deleteGoals(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getGoals"]);
    },
  });
};
